import { useState } from "react";
import { X, Calculator } from "lucide-react";
import { Button } from "@/components/ui/button";

interface SimulateurModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SimulateurModal = ({ isOpen, onClose }: SimulateurModalProps) => {
  const [surface, setSurface] = useState<string>("100");
  const [distance, setDistance] = useState<string>("20");
  const [result, setResult] = useState<number | null>(null);

  const calculate = () => {
    const surfaceNum = parseFloat(surface) || 0;
    const distanceNum = parseFloat(distance) || 0;
    const total = surfaceNum * 6 + distanceNum * 1.5;
    setResult(total);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-background/80 backdrop-blur-sm" onClick={onClose} />
      <div className="relative glass-card p-8 w-full max-w-md animate-scale-in">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-muted-foreground hover:text-foreground transition-colors"
          aria-label="Fermer"
        >
          <X className="h-5 w-5" />
        </button>

        <div className="flex items-center gap-3 mb-6">
          <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-secondary to-primary flex items-center justify-center">
            <Calculator className="h-6 w-6 text-primary-foreground" />
          </div>
          <h2 className="text-xl font-bold text-foreground">Simulateur de tarif</h2>
        </div>

        <div className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Surface de toiture (m²)
            </label>
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              value={surface}
              onChange={(e) => setSurface(e.target.value.replace(/[^0-9]/g, ''))}
              className="w-full h-12 px-4 rounded-xl bg-background border border-border text-foreground focus:outline-none focus:ring-2 focus:ring-secondary/50"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Distance depuis Rouen (km)
            </label>
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              value={distance}
              onChange={(e) => setDistance(e.target.value.replace(/[^0-9]/g, ''))}
              className="w-full h-12 px-4 rounded-xl bg-background border border-border text-foreground focus:outline-none focus:ring-2 focus:ring-secondary/50"
            />
          </div>

          <Button onClick={calculate} className="w-full" size="lg">
            Calculer mon tarif
          </Button>

          {result !== null && (
            <div className="p-4 rounded-xl bg-secondary/10 border border-secondary/20 text-center animate-fade-in">
              <p className="text-sm text-muted-foreground mb-1">Estimation indicative</p>
              <p className="text-3xl font-bold text-secondary">{result.toFixed(0)} €</p>
              <p className="text-xs text-muted-foreground mt-2">
                Tarif : 6 €/m² + 1,50 €/km de déplacement
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SimulateurModal;
